/**
 * Handles specifics for our repeater field types.
 *
 */
define( 'controllers/fields/fieldRepeater',[ 'models/fields/fieldCollection' ], function( fieldCollection ) {
	var controller = Marionette.Object.extend( {

		initialize: function() {
			// Listen for repeater field models.
			this.listenTo( nfRadio.channel( 'fields-repeater' ), 'init:fieldModel', this.setupCollection, this );

			nfRadio.channel( 'fields-repeater' ).reply( 'add:childField', this.addChildField, this );
			nfRadio.channel( 'fields-repeater' ).reply( 'receive:fields', this.receiveFields, this );
			nfRadio.channel( 'fields-repeater' ).reply( 'get:childField', this.getChildField, this );
			nfRadio.channel( 'fields-repeater' ).reply( 'process:stagedField', this.processStagedFields, this );
			nfRadio.channel( 'fields-repeater' ).reply( 'sort:repeaterField', this.sortRepeaterField, this );
			nfRadio.channel( 'fields-repeater' ).reply( 'over:repeaterField', this.overRepeaterField, this );
			nfRadio.channel( 'fields-repeater' ).reply( 'out:repeaterField', this.outRepeaterField, this );
			nfRadio.channel( 'fields-repeater' ).reply( 'stop:repeaterField', this.stopRepeaterField, this );
			nfRadio.channel( 'fields-repeater' ).reply( 'start:repeaterField', this.startRepeaterField, this );
			nfRadio.channel( 'fields-repeater' ).reply( 'update:repeaterField', this.updateRepeaterField, this );
		},

		/**
		 * When we save repeater fields, their 'fields' content will be saved as an array of objects.
		 * When a repeater field model is created, we need to hyrdate the 'fields' settings and turn it into a Backbone Collection.
		 * 
		 * @since  version
		 * @param  {[type]} fieldModel [description]
		 * @return {[type]}            [description]
		 */
		setupCollection: function( fieldModel ) {
			// The fields var will be an array of field model data.
			let fields = fieldModel.get( 'fields' );

			// Only turn it into a collection if we haven't already.
			if ( false === fields instanceof Backbone.Collection ) {
				let collection =  new fieldCollection( fields );
				fieldModel.set( 'fields', collection );

				//Allows to loop through Repeater fields to reset correct state
				collection.listenTo( nfRadio.channel( 'fields-repeater' ), 'clearEditActive', this.clearEditActive, collection );
				collection.listenTo( nfRadio.channel( 'app' ), 'after:appStart', this.clearEditActive, collection );
				
				// Listen for radio messages that a field was deleted.
				collection.listenTo( nfRadio.channel( 'fields' ), 'delete:field', this.maybeDeleteField, collection );
			}	
		},

		/**
		 * In order to delete items from within a repeater field without creating a new convention, we listen to radio messages for field deletion.
		 * We just have to make sure that these fields weren't just added to our repeater field collection.
		 * 
		 * @since  version
		 * @param  {[type]} fieldModel [description]
		 * @return {[type]}            [description]
		 */
		maybeDeleteField: function( fieldModel ) {
			// Make sure that we didn't just add this field to our repeater.
			if ( ! fieldModel.get( 'droppedInRepeater' ) ) {
				this.remove( fieldModel );
			}
			// We're done dropping now.
			fieldModel.set( 'droppedInRepeater', false );
		},

		/**
		 * Loops through our fields collection and sets editActive to false.
		 * 
		 * @param  {[type]} fieldModel field that was clicked
		 * @return void
		 */
        clearEditActive: function( model ) {
            _.each( this.models, function( field ) {
				if( model.cid !== field.cid ){
					field.set( 'editActive', true );
					field.set( 'editActive', false );
				}
            } );
		},


		/**
		 * Receive fields in the repeater field sortable zone
		 * 
		 */
		receiveFields: function( ui, that, e ) {

			if( jQuery( ui.item ).hasClass( 'nf-stage' ) ) {
				this.processStagedFields( ui, that, e );
			} else {
				this.addChildField(ui, that, e);
			}

		},	
		
		/**
		 * Add a field in the repeater fields collection
		 * 
		 * @since  3.0
		 * @return void
		 */
		addChildField: function( ui, that, e ) {

			let type = typeof ui.item !== "undefined" ? jQuery( ui.item ).data( 'id' ) : ui.get('slug'),
			droppedFieldModel = nfRadio.channel( 'fields' ).request( 'get:field', type ),
			collection = that.repeaterFieldModel.get( 'fields' ),
			fieldModel;
			
			
			//Don't process another repeater field
			if(type === "repeater") return;
			
			//If a field Model exists and comes from the builder get the field Type and delete Field Model from main collection
			if(droppedFieldModel != null){
				//Reset type based on the model
				type = droppedFieldModel.attributes.type;
				// Remove the field from the main field collection.
				nfRadio.channel( 'app' ).trigger( 'click:delete', e, droppedFieldModel );
			}

			// Get our field type model
			fieldModel = nfRadio.channel( 'fields' ).request( 'get:type', type );

			// Get our tmp ID
			let elId = nfRadio.channel( 'fields' ).request( 'get:tmpID' ) != null ? nfRadio.channel( 'fields' ).request( 'get:tmpID' ) : "tmp";
			//Add field to collection
			newField = collection.add(  { id: elId , label: fieldModel.get( 'nicename' ), type: type, repeaterField: true} );

			//Sort fields
			let sortableEl = nfRadio.channel( 'fields-repeater' ).request( 'get:sortableEl' );
			if(! jQuery(sortableEl).hasClass('ui-sortable')){
				nfRadio.channel( 'fields-repeater' ).request( 'init:sortable' );
			}
			let sortableElArray = jQuery( sortableEl ).sortable( 'toArray' );
			_.each( sortableElArray, function( element, index ) {
				if(false === element.length > 0){
					sortableElArray[index] = elId;
				} else if (element === elId) {
					sortableElArray.splice( index, 1);
				}
			});
			nfRadio.channel( 'fields-repeater' ).request( 'sort:repeaterField', sortableElArray);

			// Add our field addition to our change log.
			var label = {
				object: 'Field',
				label: newField.get( 'label' ),
				change: 'Added',
				dashicon: 'plus-alt'
			};

			var data = {
				collection: collection
			}
			
			nfRadio.channel( 'changes' ).request( 'register:change', 'addObject', newField, null, label, data );

			
			if( typeof elId !== "undefined" && typeof ui.helper !== "undefined" ){
				/*
				* Update our helper id to the tmpID.
				* We do this so that when we sort, we have the proper ID.
				*/ 
				jQuery( ui.helper ).prop( 'id', elId );
				//Sort fields in repeater
				nfRadio.channel( 'app' ).request( 'stop:fieldsSortable', ui );
				// Remove the helper. Gets rid of a weird type artifact.
				jQuery( ui.helper ).remove();
				// Trigger a drop field type event.
				nfRadio.channel( 'fields' ).trigger( 'drop:fieldType', type, elId );
			}

			return elId;

		},

		/**
		 * Get a field from a repeater field collection
		 * 
		 * @return fieldModel
		 */
		getChildField: function( childFieldID, parentFieldModel, newID ) {

			if( typeof childFieldID === "undefined") return;
			//Prepare retuned variable
			let childFieldModel;
			//Allow to retrieve parentFieldModel by the newID that contains the parent Field ID ( USed to update a field ID after saving the form )
			if( parentFieldModel == null && typeof newID !== "undefined" ){
				const parentID = newID.split('.')[0];
				parentFieldModel = nfRadio.channel( 'fields' ).request( 'get:field', parentID );
			}
			
			//Check we have the Repeater Field Model
			if( parentFieldModel ) {
				//Get the fields collection in the repeater Field model
				let repeaterFieldsCollection = parentFieldModel.get( 'fields' );
				//Get the Child Field Model
				childFieldModel = repeaterFieldsCollection.get( childFieldID );
			}
			
			return childFieldModel;
		},

		/**
		 * Add Staged fields to repeater fieldset
		 * 
		 * @paran object event dropped
		 * @param object ui dropped element
		 */
		processStagedFields( ui, that, e) {

			// Make sure that our staged fields are sorted properly.	
			nfRadio.channel( 'fields' ).request( 'sort:staging' );
			// Grab our staged fields.
			var stagedFields = nfRadio.channel( 'fields' ).request( 'get:staging' );

			// Get our current field order.
			var sortableEl = nfRadio.channel( 'fields-repeater' ).request( 'get:sortableEl' );

			let order = [];
			if ( jQuery( sortableEl ).hasClass( 'repeater' ) ) { // Sortable isn't empty
				// If we're dealing with a sortable that isn't empty, get the order.
				order = jQuery( sortableEl ).sortable( 'toArray' );
			} else { // Sortable is empty
				// Sortable is empty, all we care about is our staged field draggable.
				order = ['nf-staged-fields-drag'];
			}    
			
			// Get the index of our droped element.
			let insertedAt = order.indexOf( 'nf-staged-fields-drag' );

			// Loop through each staged fields model and insert a field.
			_.each( stagedFields.models, function( field, index ) {
				// Add our field.
				var tmpID = nfRadio.channel( 'fields-repeater' ).request( 'add:childField', field, that, e );
				// Add this newly created field to our order array.
				order.splice( insertedAt + index, 0, tmpID );
				
			} );

			// Remove our dropped element from our order array.
			insertedAt = order.indexOf( 'nf-staged-fields-drag' );
			order.splice( insertedAt, 1 );

			// Sort our fields
			nfRadio.channel( 'fields' ).request( 'sort:fields', order );
			// Clear our staging
			nfRadio.channel( 'fields' ).request( 'clear:staging' );
			// Remove our helper. Fixes a weird artifact.
			jQuery( ui.helper ).remove();

		},

		/**
		 * Sort the fields in a repeater Field
		 * 
		 * @param  Array 	order optional order array like: [field-1, field-4, field-2]
		 * @return void
		 */
		sortRepeaterField: function( order, ui, updateDB ) {
			// Add the field to this repeatable collection.
			let collection = nfRadio.channel( 'fields-repeater' ).request( 'get:repeaterFieldsCollection' );

			if ( null == updateDB ) {
				updateDB = true;
			}
			// Get our sortable element
			var sortableEl = nfRadio.channel( 'fields-repeater' ).request( 'get:sortableEl' );
			if ( jQuery( sortableEl ).hasClass( 'ui-sortable' ) ) { // Make sure that sortable is enabled
				// JS ternerary for setting our order
				var order = order || jQuery( sortableEl ).sortable( 'toArray' );
				// Loop through all of our fields and update their order value
				_.each( collection.models, function( field ) {
					// Get our current position.
					var oldPos = field.get( 'order' );
					var id = field.get( 'id' );
					if ( jQuery.isNumeric( id ) ) {
						var search = 'field-' + id;
					} else {
						var search = id;
					}
					
					// Get the index of our field inside our order array
					var newPos = order.indexOf( search ) + 1;
					field.set( 'order', newPos );
				} );

				collection.sort();
				
				if ( updateDB ) {
					// Set our 'clean' status to false so that we get a notice to publish changes
					nfRadio.channel( 'app' ).request( 'update:setting', 'clean', false );
					// Update our preview
					nfRadio.channel( 'app' ).request( 'update:db' );					
				}
			}
		},

		/**
		 * When the user drags a field type or staging over our sortable, we need to modify the helper.
		 * 
		 * @since  3.0
		 * @param  Object 	ui jQuery UI element
		 * @return void
		 */
		overRepeaterField: function( ui ) {
			if( jQuery( ui.item ).hasClass( 'nf-field-type-draggable' ) ) { // Field Type
				// String type
				var type = jQuery( ui.helper ).data( 'id' );
				// Get our field type model.
				var fieldType = nfRadio.channel( 'fields' ).request( 'get:type', type );
				// Get our field type nicename.
				var label = fieldType.get( 'nicename' );
				// Get our sortable element.
				var sortableEl = nfRadio.channel( 'fields-repeater' ).request( 'get:sortableEl' );

				// Set our currentHelper to an object var so that we can access it later.
				this.currentHelper = ui.helper;

			} else if ( jQuery( ui.item ).hasClass( 'nf-stage' ) ) { // Staging
				// Get our sortable, and if it's initialized add our hover class.
				var sortableEl = nfRadio.channel( 'fields-repeater' ).request( 'get:sortableEl' );
				if ( jQuery( sortableEl ).hasClass( 'ui-sortable' ) ) {
					jQuery( sortableEl ).addClass( 'nf-droppable-hover' );
				}
			}
		},

		/**
		 * When the user moves a draggable outside of the sortable, we need to change the helper.
		 * This returns the item to its pre-over state.
		 * 
		 * @since  3.0
		 * @param  Object 	ui jQuery UI element
		 * @return void
		 */
		outRepeaterField: function( ui ) {
			if( jQuery( ui.item ).hasClass( 'nf-field-type-draggable' ) ) { // Field Type
				/*
				 * Get our helper clone.
				 * This will let us access the previous label and classes of our helper.
				 */ 
				var helperClone = nfRadio.channel( 'drawer-addField' ).request( 'get:typeHelperClone' );
				// Set our helper label, remove our sortable class, and add the type class back to the type draggable.
				jQuery( this.currentHelper ).html( jQuery( helperClone ).html() );
				jQuery( this.currentHelper ).removeClass( 'nf-field-wrap' ).addClass( 'nf-field-type-button' ).css( { 'width': '', 'height': '' } );
				// Get our sortable and if it has been intialized, remove the droppable hover class.
				var sortableEl = nfRadio.channel( 'fields-repeater' ).request( 'get:sortableEl' );
				if ( jQuery( sortableEl ).hasClass( 'ui-sortable' ) ) {
					jQuery( sortableEl ).removeClass( 'nf-droppable-hover' );
				}
			} else if ( jQuery( ui.item ).hasClass( 'nf-stage' ) ) { // Staging
				// If we've initialized our sortable, remove the droppable hover class.
				var sortableEl = nfRadio.channel( 'fields-repeater' ).request( 'get:sortableEl' );
				if ( jQuery( sortableEl ).hasClass( 'ui-sortable' ) ) {
					jQuery( sortableEl ).removeClass( 'nf-droppable-hover' );
				}
			}
		},

		/**
		 * When we stop dragging in the sortable:
		 * remove our opacity setting
		 * remove our ui helper
		 * 
		 * @since  3.0
		 * @param  Object 	ui jQuery UI element
		 * @return void
		 */
		stopRepeaterField: function( ui ) {
			jQuery( ui.item ).css( 'opacity', '' );
			jQuery( ui.helper ).remove();
			//nfRadio.channel( 'fields' ).trigger( 'sortable:stop', ui );
		},

		/**
		 * When we start dragging in the sortable:
		 * add an opacity setting of 0.5
		 * show our item (jQuery hides the original item by default)
		 * 
		 * @since  3.0
		 * @param  Object 	ui jQuery UI element
		 * @return void
		 */
		startRepeaterField: function( ui ) {
			// If we aren't dragging an item in from types or staging, update our change log.
			if( ! jQuery( ui.item ).hasClass( 'nf-field-type-draggable' ) && ! jQuery( ui.item ).hasClass( 'nf-stage' ) ) { 
				
				// Maintain origional visibility during drag/sort.
				jQuery( ui.item ).show();

				// Determine helper based on builder/layout type.
				if(jQuery(ui.item).hasClass('nf-field-wrap')){
					var newHelper = jQuery(ui.item).clone();
				} else if(jQuery(ui.item).parent().hasClass('layouts-cell')) {
					var newHelper = $parentHelper.clone();
				} else {
					var newHelper = jQuery(ui.item).clone();
				}

				// Remove unecessary item controls from helper.
				newHelper.find('.nf-item-controls').remove();

				// Update helper with clone's content.
				jQuery( ui.helper ).html( newHelper.html() );

				jQuery( ui.helper ).css( 'opacity', '0.5' );
				
				// Add de-emphasize origional.
				jQuery( ui.item ).css( 'opacity', '0.25' );
			}
			//nfRadio.channel( 'fields' ).trigger( 'sortable:start', ui );
		},

		/**
		 * Sort our fields when we change the order.
		 * 
		 * @since  3.0
		 * @param  Object 	ui jQuery UI element
		 * @return void
		 */
		updateRepeaterField: function( ui, sortable ) {

			nfRadio.channel( 'fields-repeater' ).request( 'sort:repeaterField' );

			// If we aren't dragging an item in from types or staging, update our change log.
			if( ! jQuery( ui.item ).hasClass( 'nf-field-type-draggable' ) && ! jQuery( ui.item ).hasClass( 'nf-stage' ) ) { 

				var fieldCollection = nfRadio.channel( 'fields-repeater' ).request( 'get:repeaterFieldsCollection' );
				var dragFieldID = jQuery( ui.item ).prop( 'id' ).replace( 'field-', '' );
				var dragModel = fieldCollection.get( dragFieldID );

				// Add our change event to the change tracker.
				var data = { fields: [] };
				_.each( fieldCollection.models, function( field ) {
					var oldPos = field._previousAttributes.order;
					var newPos = field.get( 'order' );
					
					data.fields.push( {
						model: field,
						attr: 'order',
						before: oldPos,
						after: newPos
					} );

				} );

				var label = {
					object: 'Field',
					label: dragModel.get( 'label' ),
					change: 'Re-ordered from ' + dragModel._previousAttributes.order + ' to ' + dragModel.get( 'order' ),
					dashicon: 'sort'
				};

				//nfRadio.channel( 'changes' ).request( 'register:change', 'sortFields', dragModel, null, label, data );
			}

		},

	});

	
	
	return controller;
} );
